import { Button } from "@heroui/react";
import { useResumeBuilder } from "../context";
import { useNavigateWithParams } from "../hooks";

const ResumeIntroPage = () => {
    const navigate = useNavigateWithParams();
    const { resumeContent, design } = useResumeBuilder();

    return (
        <div className="flex h-full flex-1 items-center justify-center px-4">
            <div className="w-full max-w-lg space-y-8 text-center">
                <div className="space-y-2">
                    <h1 className="font-bold text-4xl">
                        {`Hallo${resumeContent.step1?.name ? ` ${resumeContent.step1.name},` : ","}`}
                    </h1>
                    <p className="text-gray-600">
                        hier können Sie in nur wenigen Minuten einen
                        professionellen Lebenslauf erstellen.
                    </p>
                    <p className="text-gray-600">
                        Diesen schicken wir Ihnen anschließend auch per E-Mail
                        zu.
                    </p>
                </div>

                <div className="flex flex-col items-center justify-center space-y-4">
                    <Button
                        className="w-full rounded-full px-8 py-3 font-medium text-white transition-colors sm:w-auto"
                        style={{
                            backgroundColor: design.resumePrimaryColor,
                            color: design.resumePrimaryContrastColor,
                        }}
                        onPress={() => {
                            navigate("/step1");
                        }}
                    >
                        Jetzt starten →
                    </Button>
                </div>
            </div>
        </div>
    );
};

export { ResumeIntroPage };
